import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { NgSelectModule } from '@ng-select/ng-select';
import { FeaturesModule } from 'libs/features/src/lib/features.module';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AdminCurrencyDialoguesService } from './admin-currency-dialogues.service';
import { CurrencyDialoguesService } from './currency-dialogues.service';
import { CurrencyConfigurationDialogue } from './currency/requirements/currency-configuration.component';
import { EditOperatingCategoriesDialogue } from './operating-categories/edit/edit-operating-categories-dialogue.component';

@NgModule({
    imports: [
        CommonModule,
        SharedUiModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        LoadingIndicatorModule,
        EnhancedHelpModule,
        FeaturesModule,
        AnalyticsModule,
        TooltipModule,
        ButtonsModule
    ],
    providers: [AdminCurrencyDialoguesService, CurrencyDialoguesService],
    declarations: [
        EditOperatingCategoriesDialogue,
        CurrencyConfigurationDialogue
    ],
    exports: [EditOperatingCategoriesDialogue, CurrencyConfigurationDialogue]
})
export class CurrencyModule {}
